class PeaceTowerWinterHero {
  constructor(section) {
    this.section = section;
    this.video = section.querySelector('[data-winter-video]');
    this.rail = section.querySelector('[data-collection-rail]');
    this.previous = section.querySelector('[data-carousel-previous]');
    this.next = section.querySelector('[data-carousel-next]');
    this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.saveData = Boolean(navigator.connection?.saveData);
    this.timer = undefined;
    this.bind();
  }

  bind() {
    if (this.video) {
      if (this.motion.matches || this.saveData) {
        this.video.pause();
        this.video.hidden = true;
      } else {
        this.video.playbackRate = 0.35;
        this.video.defaultPlaybackRate = 0.35;
        this.video.addEventListener('timeupdate', () => this.maskLoop());
        this.observer = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) this.video.play().catch(() => {});
          else this.video.pause();
        }, { threshold: 0.15 });
        this.observer.observe(this.section);
      }
    }

    this.previous?.addEventListener('click', () => this.move(-1));
    this.next?.addEventListener('click', () => this.move(1));
    for (const event of ['pointerenter', 'focusin', 'touchstart']) {
      this.rail?.addEventListener(event, () => this.stop(), { passive: true });
    }
    for (const event of ['pointerleave', 'focusout']) {
      this.rail?.addEventListener(event, () => this.start());
    }
    this.start();
  }

  maskLoop() {
    if (!this.video.duration) return;
    const nearEnd = this.video.duration - this.video.currentTime < 0.35;
    this.section.classList.toggle('is-looping', nearEnd);
    if (this.video.currentTime < 0.2) this.section.classList.remove('is-looping');
  }

  move(direction) {
    const card = this.rail?.querySelector('.pt-winter-collection');
    if (!card || !this.rail) return;
    const amount = card.getBoundingClientRect().width + 10;
    const atEnd = this.rail.scrollLeft + this.rail.clientWidth >= this.rail.scrollWidth - 4;
    if (direction > 0 && atEnd) this.rail.scrollTo({ left: 0, behavior: 'smooth' });
    else this.rail.scrollBy({ left: amount * direction, behavior: 'smooth' });
  }

  start() {
    if (this.motion.matches || !this.rail || this.timer) return;
    this.timer = window.setInterval(() => this.move(1), 9000);
  }

  stop() {
    window.clearInterval(this.timer);
    this.timer = undefined;
  }
}

document.querySelectorAll('[data-pt-winter-hero]').forEach(section => new PeaceTowerWinterHero(section));
